var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H20.25M9 12H15.75M9 18H20.25M5.25 18C5.25 18.1989 5.17098 18.3897 5.03033 18.5303C4.88968 18.671 4.69891 18.75 4.5 18.75C4.30109 18.75 4.11032 18.671 3.96967 18.5303C3.82902 18.3897 3.75 18.1989 3.75 18C3.75 17.8011 3.82902 17.6103 3.96967 17.4697C4.11032 17.329 4.30109 17.25 4.5 17.25C4.69891 17.25 4.88968 17.329 5.03033 17.4697C5.17098 17.6103 5.25 17.8011 5.25 18ZM5.25 12C5.25 12.1989 5.17098 12.3897 5.03033 12.5303C4.88968 12.671 4.69891 12.75 4.5 12.75C4.30109 12.75 4.11032 12.671 3.96967 12.5303C3.82902 12.3897 3.75 12.1989 3.75 12C3.75 11.8011 3.82902 11.6103 3.96967 11.4697C4.11032 11.329 4.30109 11.25 4.5 11.25C4.69891 11.25 4.88968 11.329 5.03033 11.4697C5.17098 11.6103 5.25 11.8011 5.25 12ZM5.25 6C5.25 6.19891 5.17098 6.38968 5.03033 6.53033C4.88968 6.67098 4.69891 6.75 4.5 6.75C4.30109 6.75 4.11032 6.67098 3.96967 6.53033C3.82902 6.38968 3.75 6.19891 3.75 6C3.75 5.80109 3.82902 5.61032 3.96967 5.46967C4.11032 5.32902 4.30109 5.25 4.5 5.25C4.69891 5.25 4.88968 5.32902 5.03033 5.46967C5.17098 5.61032 5.25 5.80109 5.25 6Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoty);
export default __webpack_public_path__ + "static/media/Categoty.fa9987a1dc5f6d1095ed219b847ee998.svg";
export { ForwardRef as ReactComponent };